import moment from 'moment';
import { notify } from 'react-notify-toast';
import { observable, action } from 'mobx';

import {
    createOrUpdate,
    getAddressByCEP,
    getProfessions,
    getwhoIndicated,
} from './services';
import {getCustomer, getCustomers} from '../../services/customers'
import {customerTemplate} from './constants'

class CustomerStore {
    @observable birthDate = new Date('2004')
    @observable customersList = []
    @observable isLoading = false
    @observable professionsList = []
    @observable professionsOptions = []
    @observable professionsValue = []
    @observable search_address = ''
    @observable whoIndicated = []
    @observable whoIndicatedOptions = []
    @observable whoIndicatedValue = []

    @observable customer = customerTemplate

    @action
    professionsLoad = async () => {
        const professions = await getProfessions()
        this.professionsOptions = professions.map(e => ({ key: e.id, text: e.name, value: e.id }))
    }

    @action
    whoIndicatedSearchEvent = async (event, value) => {
        event.preventDefault()
        if (value.searchQuery.length > 0) {
            const people = await getwhoIndicated(value.searchQuery)
            this.whoIndicatedOptions = people.map(e => ({ key: e.id, text: `${e.first_name} ${e.last_name}`, value: e.id }))
        }
    }

    @action
    handleCustomerForm = async (event) => {
        this.isLoading =true
        event.preventDefault();
        this.customer.username = this.customer.cpf;
        this.customer.password = this.customer.cpf;
        await createOrUpdate(this.customer)
        this.customer = customerTemplate
        await  this.getCustomers()
        this.isLoading = false
    }

    @action
    handleDatePicker = (dateTime) => {
        this.birthDate = dateTime
        this.updateCustomerBirthDate()
    }

    @action
    updateCustomerBirthDate = () => {
        this.customer.birth_date = moment(this.birthDate).format('YYYY-MM-DD')
    }

    @action
    handleGenericChange = (event, { name, value }) => {
        this.customer[name] = value
        if (name === 'cpf') {
            this.customer.user.username = value
        }
    }

    @action
    handleRadioIsSeller = (event, { checked }) => {
        this.customer.is_seller = checked
    }

    @action
    handleUserChange = (event, { name, value }) => {
        this.customer.user[name] = value
    }

    @action
    handleAddressChange = (event, { name, value }) => {
        this.customer.address[name] = value
    }

    @action
    handleSearchAddressChange = async (event) => {
        event.preventDefault()
        const search_address = this.search_address.replace('-', '')

        if (event.target.name === undefined) {
            if (search_address.length === 8) {
                const data = await getAddressByCEP(search_address);
                this.customer.address = data;

            }
        } else {
            this.search_address = event.target.value
        }
    }

    @action
    getCustomers = async () => {
        const customers = await getCustomers()
        this.customersList = customers
    }

    @action
    onClickTableRow = async row => {
        this.isLoading = true
        const customer = await getCustomer(row.values.id)
        if (customer.error){
            notify.show(customer.error.user+"=="+customer.error.tech, 'error')
        }else {
            customer['address'] = {
                city: ".",
                complement: ".",
                country: ".",
                neighborhood: ".",
                number: '.',
                postcode: ".",
                state: ".",
                street_address: ".",
            }
            this.customer = {
                ...customer
            }
        }
        this.isLoading = false
    }
};

export default new CustomerStore();
